export default "__VITE_ASSET__G1sr8Qx0__"